import { Component, OnDestroy } from '@angular/core';
import { MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { MerchantSearchResponse } from '@app/api/marketplace/models';
import { PartnerSearchModalComponent } from '@shared/modals/partner-search-modal/partner-search-modal.component';
import { DialogService } from '@shared/services/dialog.service';

import {
  VipDiscountsSellingActions,
  VipDiscountsSellingSelectors,
} from '../../../store/vip-discounts-selling.slice';

@Component({
  selector: 'app-vip-discounts-partners',
  templateUrl: './vip-discounts-partners.component.html',
  styleUrls: ['./vip-discounts-partners.component.scss'],
})
export class VipDiscountsPartnersComponent implements OnDestroy {
  partnersTableDataSource = new MatTableDataSource<MerchantSearchResponse>();
  displayedColumns = ['companyName', 'brandName', 'actions'];
  subs = new Subscription();

  constructor(private dialogService: DialogService, private store: Store) {
    this.store.dispatch(VipDiscountsSellingActions.clearPartners.trigger());
    this.subs.add(
      this.store
        .select(VipDiscountsSellingSelectors.selectPartners)
        .subscribe((selectedPartners) => {
          this.partnersTableDataSource.data = selectedPartners;
        })
    );
  }

  openPartnerSelector() {
    const dialogConfig: MatDialogConfig = {
      panelClass: 'partner-search-modal',
      minWidth: '60%',
      maxWidth: '80%',
    };
    this.dialogService
      .openDialog(PartnerSearchModalComponent, dialogConfig)
      .afterClosed()
      .subscribe((selection) => {
        if (selection?.length) {
          this.store.dispatch(
            VipDiscountsSellingActions.selectPartners.trigger({
              partners: selection,
            })
          );
        }
      });
  }

  deselectPartner(partner: MerchantSearchResponse) {
    this.store.dispatch(
      VipDiscountsSellingActions.deselectPartner.trigger({ partner })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
